import { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import NoSidebarNew from '../Sidebar/NoSidebarNew';
//import HeaderMainProtected from '../Header/HeaderMainProtected';
import FooterEnd from '../Footer/FooterEnd';
import { Toolbar } from '@mui/material';
import useScrollTrigger from '@mui/material/useScrollTrigger';
import Fab from '@mui/material/Fab';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import Fade from '@mui/material/Fade';


export default function PageProtectedNew({headline, main, props}) {

const [windowSize, setWindowSize] = useState({
    width: window.innerWidth,
    height: window.innerHeight
    });


useEffect(() => {
    const handleResize = () => {
        setWindowSize({
            width: window.innerWidth,
            height: window.innerHeight
        });
    };

    window.addEventListener('resize', handleResize);

    return () => {
        window.removeEventListener('resize', handleResize);
    };
}, []);

// background: 'linear-gradient(75deg, hsl(231, 14%, 82%) 10%, hsl(228, 26%, 96%) 50%)',

  return (
 <>
  
  <Container sx={{ minWidth: '100%', minHeight:windowSize.height, }}>
  
    <Grid container>   
      <Toolbar  id="back-to-top-anchor" />
      <NoSidebarNew />

      <Grid size={12} sx={{ mt: { xs:8, sm:4, md: 0,}, mb: {xs:0, sm:4, md:8, }, display: 'flex', justifyContent: 'center', alignItems: 'flex-start', }}>
      </Grid>

        <Grid size={12} sx={{mt: { xs:4, sm: 1 }, display: 'flex', justifyContent: 'center', alignItems: 'flex-start',}}>
            {/* MAIN PAGE  */}
            {main}
        </Grid>
    </Grid>
    
</Container>

<FooterEnd />

{/* Scroll Back to Top */}
  <ScrollTop targetWindow={window}>
    <Fab size="small" aria-label="scroll back to top"
      sx={{
        zIndex: 9,
        bgcolor: 'primary.C200',
        color: 'primary.C900',
        '&:hover': { color: 'tertiary.C900' },
      }}
    >
      <KeyboardArrowUpIcon />
    </Fab>
  </ScrollTop>
  </>
  )
}

/* Helper Function to show button to scroll back to top */
function ScrollTop({ children, targetWindow }) {
  const trigger = useScrollTrigger({
    target: targetWindow,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = () => {
    const anchor = document.querySelector('#back-to-top-anchor');
    anchor?.scrollIntoView({
      behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth',
      block: 'center',
    });
  };

  return (
    <Fade in={trigger}>
      <Box
        onClick={handleClick}
        role="presentation"
        sx={{
          zIndex: 14,
          position: 'fixed',
          bottom: 24,
          right: 24,
          cursor: 'pointer',
        }}
      >
        {children}
      </Box>
    </Fade>
  );
}

